// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__336N3","notes":"Notes_notes__3AvzY"};